<!-- 刻度盘配置 -->
<template>
  <div>
    <el-form-item label="仪表样式">
      <el-select :value="settings.gaugeStyle" aria-label="仪表样式" @input="setOption('gaugeStyle', $event)">
        <el-option label="经典仪表盘" value="classic" />
        <el-option label="半圆科技" value="tech" />
      </el-select>
    </el-form-item>
    <el-form-item label="最小值"><el-input-number :value="rangeValue('min')" :controls="false" label="仪表盘最小值" @change="setNumber('gaugeMin', $event)" @blur="commitNumber('gaugeMin', $event)" /></el-form-item>
    <el-form-item label="最大值"><el-input-number :value="rangeValue('max')" :controls="false" label="仪表盘最大值" @change="setNumber('gaugeMax', $event)" @blur="commitNumber('gaugeMax', $event)" /></el-form-item>
    <el-form-item label="指标名称"><el-input :value="displayName" maxlength="256" label="仪表盘顶部指标名称" placeholder="留空可隐藏指标名称" @input="setOption('gaugeLabel', $event)" /></el-form-item>
    <p v-if="rangeIssue" class="gauge-settings-help is-error" role="alert">{{ rangeIssue }}</p>
    <el-button v-if="overridden" size="mini" type="text" @click="resetDataOptions">量程和名称跟随数据</el-button>
    <p class="gauge-settings-help">未修改时沿用数据配置；修改后固定使用这里的量程和顶部名称，设备更新不会覆盖。单位仍沿用数据。独立仪表不带面板框，可搭配“组件标题”和图片框。</p>
    <p v-if="main.activeOption.echartsOption !== undefined" class="gauge-settings-help">已配置 ECharts Option，其中显式填写的样式优先。</p>
    <el-form-item label="刻度线粗度(像素)">
      <avue-input-number v-model="main.activeOption.lineSize"></avue-input-number>
    </el-form-item>
    <template v-if="settings.gaugeStyle === 'tech'">
      <el-form-item v-for="field in colorFields" :key="field.key" :label="field.label">
        <div class="gauge-color-field"><el-input :value="colorInput(field.key)" :label="'仪表盘' + field.label" placeholder="#19cfff 或 rgba(...)" @input="setOption(field.key, $event)" /><el-color-picker :value="settings[field.key]" show-alpha @change="setOption(field.key, $event || '')" /></div>
      </el-form-item>
      <el-form-item label="显示指针"><el-switch :value="settings.gaugePointer" @input="setOption('gaugePointer', $event)" /></el-form-item>
      <el-form-item label="柔光效果"><el-switch :value="settings.gaugeGlow" @input="setOption('gaugeGlow', $event)" /></el-form-item>
      <el-form-item label="显示刻度值"><el-switch :value="settings.gaugeTickLabel" @input="setOption('gaugeTickLabel', $event)" /></el-form-item>
      <el-form-item v-if="settings.gaugeTickLabel" label="刻度字号"><el-input-number :value="settings.gaugeTickFontSize" :min="8" :max="40" :precision="0" controls-position="right" label="仪表盘刻度字号" @change="setNumber('gaugeTickFontSize', $event)" @blur="commitNumber('gaugeTickFontSize', $event)" /></el-form-item>
      <el-form-item label="单位字号"><el-input-number :value="settings.gaugeUnitFontSize" :min="8" :max="60" :precision="0" controls-position="right" label="仪表盘单位字号" @change="setNumber('gaugeUnitFontSize', $event)" @blur="commitNumber('gaugeUnitFontSize', $event)" /></el-form-item>
      <el-form-item label="最多小数位"><el-input-number :value="settings.gaugePrecision" :min="0" :max="6" :step="1" :precision="0" controls-position="right" label="仪表盘最多小数位" @change="setNumber('gaugePrecision', $event)" @blur="commitNumber('gaugePrecision', $event)" /></el-form-item>
    </template>
    <template v-else>
      <el-form-item label="显示刻度值">
        <avue-switch v-model="main.activeOption.axisLabelShow"></avue-switch>
      </el-form-item>
      <el-form-item label="刻度字号">
        <avue-input-number v-model="main.activeOption.axisLabelFontSize"></avue-input-number>
      </el-form-item>
    </template>
    <el-form-item label="指标名称字号">
      <avue-input-number v-model="main.activeOption.nameFontSize"></avue-input-number>
    </el-form-item>
    <el-form-item label="指标字号">
      <avue-input-number v-model="main.activeOption.valueFontSize"></avue-input-number>
    </el-form-item>
  </div>
</template>

<script>
import { gaugePresentationSettings } from '@/runtime/gauge-presentation'
import { gaugeDisplayData, gaugeRangeIssue, hasGaugeDataOverrides } from '@/runtime/gauge-data'

export default {
  inject: ['main'],
  data: () => ({ colorFields: [{ key: 'gaugeColor', label: '主色／指针' }, { key: 'gaugeTrackColor', label: '轨道颜色' }, { key: 'gaugeTickColor', label: '刻度颜色' }, { key: 'gaugeValueColor', label: '数值颜色' }, { key: 'nameColor', label: '名称颜色' }, { key: 'gaugeUnitColor', label: '单位颜色' }] }),
  computed: {
    settings () { return gaugePresentationSettings(this.main.activeOption) },
    displayData () { return gaugeDisplayData(this.main.activeObj.data, this.main.activeOption) },
    displayName () { return typeof this.displayData.label === 'string' ? this.displayData.label : this.displayData.name || '' },
    rangeIssue () { return gaugeRangeIssue(this.main.activeObj.data, this.main.activeOption) },
    overridden () { return hasGaugeDataOverrides(this.main.activeOption) }
  },
  methods: {
    setOption (key, value) { this.$set(this.main.activeOption, key, value) },
    rangeValue (key) { const value = this.displayData[key]; return ['number', 'string'].includes(typeof value) && String(value).trim() && Number.isFinite(Number(value)) ? Number(value) : key === 'min' ? 0 : 100 },
    colorInput (key) { return typeof this.main.activeOption[key] === 'string' ? this.main.activeOption[key] : this.settings[key] },
    setNumber (key, value) {
      if (!['number', 'string'].includes(typeof value) || !String(value).trim() || !Number.isFinite(Number(value))) return
      const limits = { gaugeTickFontSize: [8, 40], gaugeUnitFontSize: [8, 60], gaugePrecision: [0, 6] }, number = Number(value)
      this.setOption(key, limits[key] ? Math.max(limits[key][0], Math.min(limits[key][1], Math.round(number))) : number)
    },
    commitNumber (key, event) { this.setNumber(key, event && event.target && event.target.value) },
    resetDataOptions () { ['gaugeMin', 'gaugeMax', 'gaugeLabel'].forEach(key => this.$delete(this.main.activeOption, key)) }
  }
}
</script>

<style scoped>
.gauge-settings-help { color: #a4b6c5; font-size: 12px; line-height: 1.6; margin: 0 0 12px; overflow-wrap: anywhere; }
.gauge-settings-help.is-error { color: #ffb59e; }
.el-select, .el-input-number { width: 100%; }
.gauge-color-field { display: flex; align-items: center; gap: 6px; min-width: 0; }
.gauge-color-field .el-input { flex: 1; min-width: 0; }
.gauge-color-field .el-color-picker { flex: none; }
</style>
